import { useEffect, useState } from 'react'

// A hook that checks if a media query like "(min-width: 1000px)" is a match.
// See the useTailwindBreakpoint hooke below to match named Tailwind breakpoints.
export function useMediaQuery(query: string): boolean {
  const matcher = window.matchMedia(query)
  const [state, setState] = useState(matcher.matches)

  useEffect(() => {
    const onChange = () => setState(matcher.matches)
    matcher.addEventListener('change', onChange)
    return () => matcher.removeEventListener('change', onChange)
  }, [])

  return state
}

// Check if the viewport width matches a Tailwind breakpoint.
export function useBreakpoint(breakpoint: keyof typeof TAILWIND_BREAKPOINTS): boolean {
  return useMediaQuery(`(min-width: ${TAILWIND_BREAKPOINTS[breakpoint]}px)`)
}

export const TAILWIND_BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
  '3xl': 1600,
  '4xl': 1800,
  '5xl': 2000,
  '6xl': 2200
}
